var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZcash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2500 2500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 529.97,
    y1: 2000.86,
    x2: 2044.6,
    y2: 486.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf8724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdce58"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "zcash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 1280.8,
    cy: 1250,
    r: 1096,
    style: {
      fill: "url(#a)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1250,2500C562.5,2500,0,1937.5,0,1250S562.5,0,1250,0,2500,562.5,2500,1250,1937.5,2500,1250,2500Zm0-2222.1c-534.6,0-972.1,437.5-972.1,972.1s437.5,972.1,972.1,972.1,972.1-437.5,972.1-972.1S1784.6,277.9,1250,277.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.1,1588.6h541.6v270.8H1443.1v229.2H1165.2V1866.5H831.8c0-90.4-13.7-180.4,7.1-263.7,7.2-41.7,55.4-83.3,90.5-125,104.2-125,208.3-250,319.6-375,41.7-48.8,83.3-90.4,132.1-145.8H860.3V686.1h305.4V457h270.8V679h333.3c0,90.5,13.8,180.4-7.1,263.8-7.1,41.6-55.4,83.3-90.4,125-104.2,125-208.4,250-319.6,375C1311,1491.5,1269.3,1539.8,1221.1,1588.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZcash);
export default __webpack_public_path__ + "static/media/zcash.2000a4fbd4d25dd93371a5736fa70334.svg";
export { ForwardRef as ReactComponent };